import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Bashkon klasa Tailwind pa konflikte vizuale.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
